// Global search in the top nav: hash / domain / IP / sample name / family /
// tag → navigate to /jobs?q=<term>. The Analyses page's existing q filter
// already searches sample filename, SHA, job id, labels, tags and
// signature client-side, so most IOC lookups land on the right rows
// without extra backend work. For deeper substring matches across
// behavior-report.json and config-report.json (C2s, mutex, keys
// embedded in extractors output), the /v1/search backend endpoint can
// be surfaced later as a secondary results view linked from this input.
import { useRef, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "@/components/ui";

export function NavSearch() {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const nav = useNavigate();

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    nav(`/jobs?q=${encodeURIComponent(q)}`);
    inputRef.current?.blur();
  };

  return (
    <form onSubmit={submit} role="search" className="nav-search" aria-label="Search Analyses">
      <Search
        value={value}
        onChange={setValue}
        label="Search by hash, domain, IP, family, filename, tag"
        placeholder="hash, domain, IP, family"
        inputRef={inputRef}
      />
    </form>
  );
}
